import { render, staticRenderFns } from "./CardListado.vue?vue&type=template&id=1c26bf41&scoped=true&"
import script from "./CardListado.vue?vue&type=script&lang=js&"
export * from "./CardListado.vue?vue&type=script&lang=js&"
import style0 from "./CardListado.vue?vue&type=style&index=0&id=1c26bf41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26bf41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDivider,VIcon,VList,VPagination})
